/**
 * Inquiry form validation schema - Single responsibility for validation rules
 */

import { z } from "zod";
import { validateArgentinaPhone } from "@/lib/validation/argentina-phone";

export function createInquirySchema(getMessage: (key: string) => string) {
  return z
    .object({
      fecha: z.string().nonempty(),
      horario: z.string().nonempty(),
      horarioHasta: z.string().nonempty(),
      cancha: z.string().nonempty(),
      telefono: z.string().min(1, { message: getMessage("form.phoneInvalid") }),
      nombre: z.string().min(1),
      monto: z.number().optional(),
      email: z.string().email().optional(),
    })
    .refine(
      (data) => {
        const result = validateArgentinaPhone(data.telefono);
        return result.valid;
      },
      {
        message: getMessage("form.phoneInvalid"),
        path: ["telefono"],
      }
    );
}

export type InquirySchema = ReturnType<typeof createInquirySchema>;
